import http from "@/shared/services/http";
import {ComplaintParams} from "@/modules/complaint/params";

export const singleComplaint = (id: number) => http.get(`v1/complaints/${id}`);
export const createComplaint = (data: any) => http.post(`v1/complaints`, data);
export const listComplaint = (params?: ComplaintParams) => http.get(`v1/complaints`, {params});
export const allComplaint = (params?: ComplaintParams) => http.get(`v1/complaints/all`, {params});
export const updateComplaint = (id: number, data: any) => http.put(`v1/complaints/${id}`, data);
